import { render, staticRenderFns } from "./ShotClock.vue?vue&type=template&id=85931878"
import script from "./ShotClock.vue?vue&type=script&lang=ts"
export * from "./ShotClock.vue?vue&type=script&lang=ts"
import style0 from "./ShotClock.vue?vue&type=style&index=0&id=85931878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports